<template >
  <div id="app">
    <lottie
      :options="defaultOptions"
      :autoplay="true"
      :speed="0.05"
      :loop="false"
      :height="200"
      :width="200"
      class="animation1"
      v-on:animCreated="handleAnimation"
    />
  
  </div> 
</template>

<style scoped>
.app {
  background-attachment: fixed;
  background-position: center;
  width:500px;
  height:500px;
  display:block;
  overflow: hidden;
  transform: translate3d(0,0,0);
  text-align: center;
  opacity: 1;
}
.text-color {
  color: #fff !important;
}
.animation1 {
  position: absolute;
  bottom: -190px;
  font-size: 15px; 
  min-height: 0px;
  left: 35px;
  -webkit-animation: fadeIn linear 8s forwards;
  -moz-animation: fadeIn linear 8s forwards;
  -o-animation: fadeIn linear 8s forwards;
  -ms-animation: fadeIn linear 8s forwards;
  animation: fadeIn linear 8s forwards;
}

@keyframes fadeIn {
  0% {opacity:0;}
  100% {opacity:1;}
}

@-moz-keyframes fadeIn {
  0% {opacity:0;}
  100% {opacity:1;}
}

@-webkit-keyframes fadeIn {
  0% {opacity:0;}
  100% {opacity:1;}
}

@-o-keyframes fadeIn {
  0% {opacity:0;}
  100% {opacity:1;}
}

@-ms-keyframes fadeIn {
  0% {opacity:0;}
  100% {opacity:1;}
}

@media only screen and (max-width: 600px) {
  .animation1 {
  position: absolute;
  bottom: -215px;
  font-size: 15px; 
  min-height: 0px;
  left: 20px;
  -webkit-animation: fadeIn linear 8s forwards;
  -moz-animation: fadeIn linear 8s forwards;
  -o-animation: fadeIn linear 8s forwards;
  -ms-animation: fadeIn linear 8s forwards;
  animation: fadeIn linear 8s forwards;
}

@keyframes fadeIn {
  0% {opacity:0;}
  100% {opacity:1;}
}

@-moz-keyframes fadeIn {
  0% {opacity:0;}
  100% {opacity:1;}
}

@-webkit-keyframes fadeIn {
  0% {opacity:0;}
  100% {opacity:1;}
}

@-o-keyframes fadeIn {
  0% {opacity:0;}
  100% {opacity:1;}
}

@-ms-keyframes fadeIn {
  0% {opacity:0;}
  100% {opacity:1;}
}
}  
</style>

<script>
// import Lottie from "./lottie.vue";
import Lottie from "vue-lottie";
import * as animationData from "./../assets/mockups/hud-circle3.json";

export default {
  name: "Animation9",
  components: {
    lottie: Lottie
  },
  data: () => ({
    defaultOptions: { animationData: animationData.default },
  }),
  methods: {
    handleAnimation: function(anim) {
      this.anim = anim;
    },
  }
};
</script>